<template>  
  <div>
    <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
      <a class="navbar-brand col-sm-3 col-md-2 mr-0" href="#">서울음향 관리자</a>
      <input class="form-control form-control-dark w-100" type="text" placeholder="Search" aria-label="Search"
      v-model="search.keyword">
      <ul class="navbar-nav px-3">
        <li class="nav-item text-nowrap">
          <a class="nav-link" @click="logout()">Sign out</a>
        </li>
      </ul>
    </nav>
    <div class="container-fluid">
      <div class="row">
        <nav class="col-md-2 d-none d-md-block bg-light sidebar">
          <div class="sidebar-sticky">
            <ul class="nav flex-column">
              <li class="nav-item">
                <a class="nav-link active" href="#">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-users"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                  사용자 관리 <span class="sr-only">(current)</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-4"><div class="chartjs-size-monitor" style="position: absolute; left: 0px; top: 0px; right: 0px; bottom: 0px; overflow: hidden; pointer-events: none; visibility: hidden; z-index: -1;"><div class="chartjs-size-monitor-expand" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;"><div style="position:absolute;width:1000000px;height:1000000px;left:0;top:0"></div></div><div class="chartjs-size-monitor-shrink" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;"><div style="position:absolute;width:200%;height:200%;left:0; top:0"></div></div></div>
          <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 class="h2">사용자 관리</h1>
            <div class="btn-toolbar mb-2 mb-md-0">
              <div class="btn-group mr-2">
                <b-btn v-b-modal.modal1>사용자 추가</b-btn>
              </div>
            </div>
          </div>
          <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h6 class="border-bottom border-gray pb-2 mb-0">
            <b-form-group>
              <span v-if="search.keyword">'{{search.keyword}}' 검색결과</span>
            목록 <span>({{total}} 사용자)</span>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox id="checkbox1"
                     v-model="search.filterBlocked">
                차단된 사용자 숨김
              </b-form-checkbox>
            </b-form-group>
            </h6>
            <div class="media text-muted pt-3"
            v-for="user in users"
            :key="user.id">
              <div class="media-body pb-3 mb-0 small lh-125 border-bottom border-gray">
                <div class="d-flex justify-content-between align-items-center w-100">
                  <strong class="text-gray-dark">#{{ user.mailuser_id }}. 
                    <span>{{user.name}} (그룹웨어: {{user.gw_name}})</span> 
                    <span class="badge badge-primary" v-if="user.gw_admin">관리권한</span>
                  </strong>
                </div>
                <span class="d-block">{{ user.email }}</span>
              </div>
              <div class="media-body pb-3 mb-0 small lh-125 border-bottom border-gray w-100">
                <div class="">
                  <button type="button" class="btn btn-light mr-2" 
                  @click="changePassword(user)">비밀번호 변경</button>
                  <button type="button" class="btn btn-danger"
                  v-if="user.postfix == 'y'"
                  @click="blockUser(user, $event)">차단</button>
                  <button type="button" class="btn btn-warning"
                  v-if="user.postfix == 'n'"
                  @click="unblockUser(user, $event)">차단해제</button>
                </div>
              </div>
            </div>
            <small class="d-block text-right mt-3">
              <a href="javascript:;" @click="searchMore()"
              v-if="users.length < total">결과 더 보기</a>
            </small>
            <a id="bottom"></a>
          </div>
          <AddUserForm></AddUserForm>
          <ChangePasswordForm :user="selectedUser"></ChangePasswordForm>
        </main>
      </div>
    </div>
    
  </div>
</template>

<script>
import AddUserForm from './AddUserForm.vue'
import ChangePasswordForm from './ChangePasswordForm.vue'

import debounce from 'debounce'

export default {
  data () {
    return {
      users: [],
      search: {
        keyword: '',
        filterBlocked: false
      },
      selectedUser: {},
      page: 1,
      total: 0
    }
  },
  methods: {
    searchUser () {
      window.console.log(this.search)
      this.$http.get('crew', {
        params: {
          page: this.page, 
          keyword: this.search.keyword, 
          filter_blocked: this.search.filterBlocked
        }
      })
      .then(response => {
        this.users = response.data.results
        this.nextSearch = response.data.next
        this.total = response.data.count
      })
    },
    searchMore () {
      this.$http.get(this.nextSearch)
      .then(response => {
        this.users.push.apply(this.users, response.data.results)
        this.nextSearch = response.data.next
        this.total = response.data.count
      })
    },
    blockUser (user, $event) {
      if (confirm('정말 ' + user.name + ' 사용자를 차단하시겠습니까?')) {
        $event.target.disabled = true
        this.$http.delete('crew/'+user.mailuser_id)
        .then(response => {
          $event.target.disabled = false
          window.console.log(response)
          this.searchUser()
        })
      }
    },
    unblockUser (user, $event) {
      $event.target.disabled = true
      this.$http.post('crew/'+user.mailuser_id+'/activate/', {})
      .then(response => {
        $event.target.disabled = false
        window.console.log(response)
        this.searchUser()
      })
    },
    changePassword (user) {
      this.selectedUser = user
      this.$root.$emit('bv::show::modal','passwordModal')
    },
    logout () {
      this.$http.defaults.headers.common = {}
      localStorage.removeItem('token')
      window.location.href = '/'      
    }
  },
  watch: {
    search: {
      handler: debounce(function () {
        window.console.log('change')
        this.searchUser()
      }, 500),
      deep: true
    } 
  },
  components: {
    AddUserForm, ChangePasswordForm
  },
  created () {
    this.searchUser()
  }
}
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100; /* Behind the navbar */
  padding: 48px 0 0; /* Height of navbar */
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
}

.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: 0.5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sidebar-sticky {
    position: -webkit-sticky;
    position: sticky;
  }
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: 0.75rem;
  text-transform: uppercase;
}

/*
 * Content
 */

[role="main"] {
  padding-top: 48px; /* Space for fixed navbar */
}

/*
 * Navbar
 */

.navbar-brand {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 1rem;
  background-color: rgba(0, 0, 0, 0.25);
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.25);
}

.navbar .form-control {
  padding: 0.75rem 1rem;
  border-width: 0;
  border-radius: 0;
}

.form-control-dark {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.1);
}

.form-control-dark:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);
}
</style>
